import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Settings\BrandController::edit
* @see app/Http/Controllers/Settings/BrandController.php:14
* @route '/settings/brand'
*/
export const edit = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/settings/brand',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Settings\BrandController::edit
* @see app/Http/Controllers/Settings/BrandController.php:14
* @route '/settings/brand'
*/
edit.url = (options?: RouteQueryOptions) => {
    return edit.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\BrandController::edit
* @see app/Http/Controllers/Settings/BrandController.php:14
* @route '/settings/brand'
*/
edit.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\BrandController::edit
* @see app/Http/Controllers/Settings/BrandController.php:14
* @route '/settings/brand'
*/
edit.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Settings\BrandController::edit
* @see app/Http/Controllers/Settings/BrandController.php:14
* @route '/settings/brand'
*/
const editForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\BrandController::edit
* @see app/Http/Controllers/Settings/BrandController.php:14
* @route '/settings/brand'
*/
editForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\BrandController::edit
* @see app/Http/Controllers/Settings/BrandController.php:14
* @route '/settings/brand'
*/
editForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Settings\BrandController::update
* @see app/Http/Controllers/Settings/BrandController.php:23
* @route '/settings/brand'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/settings/brand',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Settings\BrandController::update
* @see app/Http/Controllers/Settings/BrandController.php:23
* @route '/settings/brand'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\BrandController::update
* @see app/Http/Controllers/Settings/BrandController.php:23
* @route '/settings/brand'
*/
update.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Settings\BrandController::update
* @see app/Http/Controllers/Settings/BrandController.php:23
* @route '/settings/brand'
*/
const updateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\BrandController::update
* @see app/Http/Controllers/Settings/BrandController.php:23
* @route '/settings/brand'
*/
updateForm.patch = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

const brand = {
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
}

export default brand